import { type LayoutNodeStyleMap, type LayoutNodeContentMap } from 'app/shop-ui/types';

export function getUIStyle(style?: LayoutNodeStyleMap) {
    return (id: string) => style?.[id] || {};
}

export function getUIContent(content?: LayoutNodeContentMap) {
    return (id: string) => content?.[id] || '';
}
